import { ofType } from 'redux-observable';
import { switchMap, mergeMap } from 'rxjs/operators';

import {
    fetchGeneralAccountSummary as fetchGeneralAccountSummaryAction,
    replaceGeneralAccountSummary,
    fetchGeneralAccountSummaryError,
} from '@perpay-web/fintech/actions/shared/generalAccountSummary';
import { GENERAL_ACCOUNT_SUMMARY_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';

export const fetchGeneralAccountSummary = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchGeneralAccountSummaryAction().type),
        switchMap(() => get(GENERAL_ACCOUNT_SUMMARY_ENDPOINT)),
        mergeMap((results) => [replaceGeneralAccountSummary(results.response)]),
        handleErrorMessageWithFallback((error) => [
            fetchGeneralAccountSummaryError(error),
        ]),
    );
